import React from 'react';

import { useConfirmModal } from '@/contexts/ConfirmModalContext';
import DrawerTitle from '@/components/common/DrawerTitle';
import ConfirmModalContent from '@/components/layouts/ConfirmModalContent';

interface TacticalboardDrawerProps {
  onCloseDrawer: () => void;
}

/**
 * ドロワー（サッカーボード）
 * @param param0
 * @returns
 */
const TacticalboardDrawer: React.FC<TacticalboardDrawerProps> = ({ onCloseDrawer }) => {
  /**
   * React context
   */
  const { openConfirmModal, closeConfirmModal } = useConfirmModal();

  /**
   * 確認モーダルOK時の処理
   */
  const handleConfirmCloseOK = () => {
    // 確認モーダル閉じる（このタイミングがUX的に重要）
    closeConfirmModal();
    onCloseDrawer();
  };

  /**
   * 確認モーダル表示
   */
  const handleConfirmClose = () => {
    openConfirmModal(
      <ConfirmModalContent onClickOKCallback={handleConfirmCloseOK}>
        サッカーボードアプリを終了します。
        <br />
        よろしいですか？
      </ConfirmModalContent>
    );
  };

  return (
    <>
      <div className="h-full flex flex-col w-full bg-white border-0 rounded-t-lg outline-none focus:outline-none">
        <div className="flex justify-between items-center border-b border-green-500 px-4 py-2 bg-white sticky top-0 rounded-t-lg">
          <DrawerTitle>
            <span className="text-base font-footballlog italic">Tactical Board</span>
          </DrawerTitle>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handleConfirmClose}
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close menu</span>
            </button>
          </div>
        </div>
        <iframe
          id="tacticalboard"
          width="100%"
          height="100%"
          src="/tacticalboardv2/index.html"
          allowFullScreen>
        </iframe>
      </div>
    </>
  );
};

export default TacticalboardDrawer;
